import { useEffect, useState } from 'react';

type WindowDimensions = {
  width: number;
  height: number;
};

function getWindowDimensions() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
}

export default function useWindowDimensions(): WindowDimensions {
  const [windowDimensions, setWindowDimensions] = useState({ width: 0, height: 0 });

  function handleResize() {
    setWindowDimensions(getWindowDimensions());
  }

  useEffect(() => {
    window.addEventListener('load', handleResize);
    return () => window.removeEventListener('load', handleResize);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}
